import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";
import { useApiKeyInput } from "@/hooks/useApiKeyInput";
import { useTranslation } from "react-i18next";
import { Loading } from "@/components/ui/loading";
import { ControlWrapper } from "@/components/ui/control-wrapper";

export function ApiKeyInput() {
  const { t } = useTranslation();
  const { apiKey, isLoading, showPassword, handleChange, togglePasswordVisibility, handleSaveApiKey } = useApiKeyInput();

  return (
    <ControlWrapper>
      <div className="flex items-center justify-between">
        <Label htmlFor="api-key">{t("infoSection.heygenApiKey")}</Label>
      </div>
      <form
        onSubmit={e => {
          e.preventDefault();
          handleSaveApiKey();
        }}
      >
        <div className="flex gap-0">
          <div className="relative flex-1">
            <Input
              id="api-key"
              value={apiKey}
              onChange={handleChange}
              placeholder={t("infoSection.enterApiKey")}
              disabled={isLoading}
              type={showPassword ? "text" : "password"}
              className="flex-1 rounded-r-none border-r-0 pr-8"
            />
            {isLoading && (
              <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
                <Loading inline spinnerSize="h-4 w-4" />
              </div>
            )}
          </div>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="border-1 flex items-center justify-center rounded-l-none border border-l-0 bg-gray-100 hover:bg-gray-200"
            onClick={togglePasswordVisibility}
          >
            {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          </Button>
        </div>
      </form>
    </ControlWrapper>
  );
}
